export const purchasablesApiUrls = {
  purchasables: '/api/v1/purchasables',
  getPurchasableByCode: '/api/v1/purchasables/{code}',
  getSpecificPurchasable: '/api/v1/purchasables/specific/{code}',
};
